import size from 'lodash/size';

export type Season = 'spring' | 'summer' | 'fall' | 'winter';

const SEASONS: Season[] = ['spring', 'summer', 'fall', 'winter'];

const SEASON_COUNT = size(SEASONS);

export const getSeasonByIndex = (index: number): Season => {
	return SEASONS[index % SEASON_COUNT];
};
